<template>
    <div class="flex mt-[42px] mb-[42px] justify-between h-[42px]">
        <h1
            class="text-[21px] font-medium leading-normal tracking-small text-gray-800"
        >
            {{ $t("vue.changelog") }}
        </h1>
    </div>

    <div class="mx-auto pb-[42px] xl:max-w-[1528px]">
        <div class="space-y-8">
            <div
                v-for="e in entries"
                :key="e.version + e.release_date"
                class="grid-cols-layout pb-5 lg:grid"
            >
                <!--                <div class="col-span-12 lg:col-span-3">-->
                <!--                    <div class="text-gray-800">-->
                <!--                        <div class="text-sm font-semibold text-gray-700">-->
                <!--                            {{ e.version }}-->
                <!--                        </div>-->
                <!--                        <div class="mt-1 text-xs text-gray-500">-->
                <!--                            Release date: {{ e.release_date }}-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div class="mb-6 lg:mb-0 lg:mt-4">
                    <h3
                        class="gray-800 mb-[5px] text-lg font-medium leading-normal tracking-small"
                    >
                        {{ e.version }}
                    </h3>
                    <p class="max-w-xs text-sm text-gray-500">
                        {{ $t("vue.release_date") }}: {{ e.release_date }}
                    </p>
                </div>

                <div
                    class="mx-auto w-full rounded-md bg-white shadow-card lg:mx-0"
                >
                    <div class="p-6">
                        <div class="space-y-6">
                            <div
                                v-for="(b, idx) in e.blocks"
                                :key="e.version + '-b-' + idx"
                            >
                                <h4 class="text-lg font-medium text-gray-900">
                                    {{ b.title }}
                                </h4>

                                <div
                                    v-if="b.description"
                                    class="mt-1 text-sm text-gray-600"
                                >
                                    {{ b.description }}
                                </div>

                                <ul
                                    v-if="b.items?.length"
                                    class="mt-2 list-disc pl-5 text-sm text-gray-700 space-y-1"
                                >
                                    <li v-for="(it, i) in b.items" :key="i">
                                        {{ it }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="!entries?.length"
                class="rounded-md bg-white shadow-card p-6"
            >
                <div class="text-sm font-medium text-gray-900">
                    {{ $t("vue.no_changelog_entries") }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useTranslations } from "@/composables/useTranslations.ts";

const { t } = useTranslations();

type ChangelogBlock = {
    title: string;
    description: string;
    items: string[];
};

type ChangelogEntry = {
    version: string;
    release_date: string;
    blocks: ChangelogBlock[];
};

defineProps<{
    entries: ChangelogEntry[];
}>();
</script>
